export default {
  resize: 5,
  drag: 5,
  rotation: 5,
};
